// refer-a-friend.js
// 1. Set referral code button text from ?refcode= param, fallback to 'TINOTHY'
// 2. Make the custom button open the share sheet with ?reflink= param, fallback to 'https://tincan.kids'

document.addEventListener('DOMContentLoaded', function () {
  // 1. Referral code button
  var params = new URLSearchParams(window.location.search);
  var refCode = params.get('refcode') || 'TINOTHY';
  var refLink = params.get('reflink') ? decodeURIComponent(params.get('reflink')) : 'https://tincan.kids';

  var codeBtn = document.querySelector('.referral-code-btn');
  var referralCodeSection = document.querySelector('.referral-code');
  var refCodeParam = params.get('refcode');
  var hasValidRefCode = refCodeParam && refCodeParam.trim() !== '';
  if (hasValidRefCode) {
    if (referralCodeSection) {
      referralCodeSection.style.display = '';
    }
  } else {
    if (referralCodeSection) {
      referralCodeSection.style.display = 'none';
    }
  }
  if (codeBtn) {
    codeBtn.textContent = 'FRIEND-' + refCode;
    codeBtn.addEventListener('click', function () {
      // Copy code to clipboard
      navigator.clipboard.writeText('FRIEND-' + refCode).then(function () {
        codeBtn.textContent = 'Copied!';
        setTimeout(function () {
          codeBtn.textContent = 'FRIEND-' + refCode;
        }, 1200);
      });
    });
  }

  // 2. Custom share button (now using #refer-friend-button)
  var shareBtn = document.getElementById('refer-friend-button');
  if (shareBtn) {
    shareBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var shareData = {
        title: 'Tin Can – The New School Landline for Friends',
        text: 'We just got a Tin Can — a screen-free, WiFi landline for kids! Use my link to save 5%',
        url: refLink
      };
      if (navigator.share) {
        navigator.share(shareData).catch(function(err) {
          // fallback: open link in new tab
          window.open(refLink, '_blank');
        });
      } else {
        // fallback: open link in new tab
        window.open(refLink, '_blank');
      }
    });
  }
});

// test link: https://tincan.kids/pages/refer?refcode=TESTCODE&reflink=https://tincan.refr.cc/ref-test/u/testtestmax?s=klf&t=kl